import script from "./ActFastModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ActFastModal.vue?vue&type=script&setup=true&lang=js"

import "./ActFastModal.vue?vue&type=style&index=0&id=4ca71250&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca71250"]])

export default __exports__